import React from 'react';

export default function BannerRiderect() {
	return (
		<div className='bg-paua-pink w-full z-20 flex items-center justify-center'>
			<a
				href='http://paua.com'
				className='text-paua-deep-blue w-full font-bold text-lg whitespace-nowrap text-center py-3'
				rel='noreferrer'
			>
				<span className='font-semibold'>Our website has moved to </span>
				<span className='underline'>paua.com</span>
			</a>
		</div>
	);
}
